export default {"src":"/_next/static/media/warwick-university.c27352db.gif","height":640,"width":640,"blurWidth":0,"blurHeight":0};